<template>
    <div>
        <ToastMessage ref="toastMessage" :message="toast.message" :snackbarColor="toast.type"></ToastMessage>
        <notifications group="app"></notifications>
        <Inform ref="Inform"></Inform>
        <ProjectSelector ref="ProjectSelector"></ProjectSelector>
        <CreateApiKey ref="CreateApiKey"></CreateApiKey>
        <v-dialog v-model="modalCreateProject.show" persistent width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Create project
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm12 md12>
                                <v-form v-on:submit.prevent="createProject">
                                    <v-text-field
                                        ref="refProjectName"
                                        label="Project name*"
                                        required
                                        v-model="modalCreateProject.projectName"
                                        :error-messages="modalCreateProject.errorMessages"
                                    ></v-text-field>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="modalCreateProject.show = false">CANCEL</v-btn>
                    <v-btn flat @click="createProject" color="primary">CREATE</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Confirm ref="Confirm"></Confirm>
    </div>
</template>
<script>
import ToastMessage from '@/modules/fptai/components/ToastMessage'
import Confirm from '@/modules/fptai/components/Confirm'
import Inform from '@/modules/fptai/components/Inform'
import ProjectService from '@/services/project.service'
import ApiService from '@/services/apis.service'
import ProjectSelector from './ProjectSelector'
import CreateApiKey from './CreateApiKey'
import { EventBus, EventBusType } from '@/event-bus'

export default {
    name: 'AppServiceView',
    components: {
        ToastMessage,
        ProjectSelector,
        Confirm,
        CreateApiKey,
        Inform
    },
    data () {
        return {
            modal: {
                show: false,
                dialog: false,
                content: null,
                isText: false,
                onClose: null
            },
            toast: {
                message: '',
                type: ''
            },
            modalCreateProject: {
                show: false,
                errorMessages: '',
                projectName: '',
                apiId: '',
                nextAction: ''
            }
        }
    },
    mounted () {
        EventBus.$on(EventBusType.INFORM, ({ message, options }) => {
            this.$refs.Inform.open(message, options)
        })
        EventBus.$on(EventBusType.CLOSE_INFORM, () => {
            this.$refs.Inform.close()
        })
        EventBus.$on(EventBusType.TOAST, options => {
            this.$notify(options)
        })
        EventBus.$on(EventBusType.CREATE_PROJECT, ({ nextAction, apiId }) => {
            this.modalCreateProject.show = true
            this.modalCreateProject.nextAction = nextAction
            this.modalCreateProject.apiId = apiId
        })
        EventBus.$on(EventBusType.SELECT_PROJECT, options => {
            this.$refs.ProjectSelector.open().then(
                result => EventBus.$emit(EventBusType.SELECT_PROJECT_DONE, result)
            )
        })
        EventBus.$on(EventBusType.CONFIRM, message => {
            this.$refs.Confirm.open(message).then(
                result => EventBus.$emit(EventBusType.CONFIRM_DONE, result)
            )
        })
        EventBus.$on(EventBusType.CREATE_API_KEY, options => {
            this.$refs.CreateApiKey.open().then(
                result => EventBus.$emit(EventBusType.CREATE_API_KEY_DONE, result)
            )
        })
    },
    methods: {
        setupModalData (content, options) {
            this.modal.isText = typeof (content) === 'string'
            console.log(this.modal.isText)
            this.modal.content = content
            if (options) {
                this.modal.onClose = options.onClose
            }
        },
        onModalClose () {
            if (this.modal.onClose) {
                this.modal.onClose()
            }
        },
        async createProject () {
            // validate project name
            if (this.projectName === '') {
                this.modalCreateProject.errorMessages = this.$t('modalCreateProject.projectNameNull')
                this.$nextTick(this.$refs.refProjectName.focus())
                return false
            } else {
                this.modalCreateProject.errorMessages = ''
            }
            // create project
            this.$store.dispatch(this.$actionTypes.LOADING, true)
            let resCreateProject = await ProjectService.createProject(this.modalCreateProject.projectName)
            this.modalCreateProject.show = false
            if (!resCreateProject.status) {
                this.$store.dispatch(this.$actionTypes.LOADING, false)
                this.$appService.toastError(
                    resCreateProject.data.detail
                        ? resCreateProject.data.detail
                        : this.$t('modalCreateProject.createProjectFailed')
                )
            } else {
                if (this.modalCreateProject.nextAction === 'dashboard') {
                    this.$store.dispatch(this.$actionTypes.LOADING, false)
                    this.$router.push('/project/' + resCreateProject.data.id + '/dashboard')
                } else if (this.modalCreateProject.nextAction === 'apiDetails') {
                    const responseEnable = await ApiService.enableAPIKey(resCreateProject.data.id, this.modalCreateProject.apiId)
                    this.$store.dispatch(this.$actionTypes.LOADING, false)
                    if (responseEnable.enable) {
                        this.$appService.toastSuccess(this.$t('enableApiSuccess'))
                        this.$router.push('/project/' + resCreateProject.data.id + '/apis/' + this.modalCreateProject.apiId + '?tab=overview')
                    } else {
                        this.$appService.toastError(this.$t('enableApiFail'))
                    }
                }
            }
        }
    }
}
</script>
<style>
    .notifications {
        top: 15px !important;
        right: 15px !important;
    }

    .vue-notification {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        border-radius: 3px;
    }
</style>
